module.exports = __webpack_public_path__ + "static/media/lc.dfc467de.svg";